module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "touch",
      rawName: "v-touch:swipe.top",
      value: (_vm.swipeup),
      expression: "swipeup",
      arg: "swipe",
      modifiers: {
        "top": true
      }
    }, {
      name: "touch",
      rawName: "v-touch:swipe.bottom",
      value: (_vm.swipedown),
      expression: "swipedown",
      arg: "swipe",
      modifiers: {
        "bottom": true
      }
    }],
    class: {
      english: _vm.$i18n.locale == 'en'
    }
  }, [_c('headLine', {
    ref: "dialog",
    attrs: {
      "showbar": "true",
      "index": "8"
    },
    on: {
      "on-locale-change": _vm.onLocaleChange
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('solution3.name')) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    attrs: {
      "src": _vm.imglist[0],
      "alt": ""
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "banner_title",
    staticStyle: {
      "top": "2.77rem"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.banner_text'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "center",
    staticStyle: {
      "position": "absolute",
      "top": "4.4rem",
      "width": "100%"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/download"
    }
  }, [_c('a', {
    staticClass: "button_default",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.banner_botton'))
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content center"
  }, [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    staticStyle: {
      "width": "90%",
      "margin": "0 auto"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.title1'))
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_text content_item_text1",
    staticStyle: {
      "width": "90%",
      "margin-left": "auto",
      "margin-right": "auto",
      "text-align": "justify"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text1'))
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text2'))
    }
  }), _vm._v(" "), (_vm.$i18n.locale == 'ch') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[1]),
      expression: "imglist[1]"
    }],
    staticStyle: {
      "width": "6.86rem",
      "height": "3.37rem",
      "margin": "0.7rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$i18n.locale == 'en') ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[10]),
      expression: "imglist[10]"
    }],
    staticStyle: {
      "width": "6.86rem",
      "height": "3.37rem",
      "margin": "0.7rem auto 0 auto"
    },
    attrs: {
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "content_item",
    staticStyle: {
      "background": "#f3f9ff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', [_c('div', {
    staticClass: "picture_list clearfix"
  }, [_c('div', {
    staticClass: "fl left_pic "
  }, [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text4'))
    }
  }, [_vm._v("\n                      秀场VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[2]),
      expression: "imglist[2]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fr right_pics"
  }, [_c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text6'))
    }
  }, [_vm._v("\n                      体育VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[3]),
      expression: "imglist[3]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "pic_box"
  }, [_c('div', {
    staticClass: "middle pic_box_text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text8'))
    }
  }, [_vm._v("\n                      演出VR直播\n                    ")]), _vm._v(" "), _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imglist[4]),
      expression: "imglist[4]"
    }],
    staticStyle: {
      "margin-top": "0"
    },
    attrs: {
      "alt": ""
    }
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "content_item",
    staticStyle: {
      "padding-bottom": "0.7rem"
    }
  }, [_c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text19'))
    }
  }, [_vm._v(" \n              威尔云 6 大特性 \n            ")]), _vm._v(" "), _c('div', {
    staticClass: "feature clearfix"
  }, [_c('div', {
    staticClass: "fl"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "feature_pic feature_pic1"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text20'))
    }
  }, [_vm._v(" \n                      低宽带\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic5"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text24'))
    }
  }, [_vm._v(" \n                      低功耗\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic7"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text28'))
    }
  }, [_vm._v(" \n                      服务稳定可靠\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fr"
  }, [_c('ul', [_c('li', [_c('span', {
    staticClass: "feature_pic feature_pic2"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text22'))
    }
  }, [_vm._v(" \n                      低延迟\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic3"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text26'))
    }
  }, [_vm._v(" \n                      标准协议\n                    ")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "feature_pic feature_pic6"
  }), _vm._v(" "), _c('h3', {
    staticClass: "content_item_title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('solution3.text30'))
    }
  }, [_vm._v(" \n                      多终端适配\n                    ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [_c('router-link', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "0.2rem"
    },
    attrs: {
      "to": "/technology"
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text32')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "content_item ",
    staticStyle: {
      "background": "#f3f9ff",
      "padding-bottom": "0.7rem"
    }
  }, [_c('div', {
    attrs: {
      "clas": "multi-platform"
    }
  }, [_c('h3', {
    staticClass: "content_item_title"
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('solution3.text33')) + "\n                    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "multi-platform_button"
  }, [_c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-top": "2.48rem"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.showDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text34')))])])])]), _vm._v(" "), _c('div', {
    staticClass: "requestion_wrap"
  }, [_c('div', {
    staticClass: "requestion"
  }, [_c('h3', {
    staticClass: "requestion_title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('solution3.text35')) + "\n              ")]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show1 = !_vm.show1
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text36'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show1
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show1),
      expression: "show1"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text37')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show2 = !_vm.show2
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text38'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show2
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show2),
      expression: "show2"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text39')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show3 = !_vm.show3
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text40'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show3
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show3),
      expression: "show3"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text41')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show4 = !_vm.show4
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text42'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show4
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show4),
      expression: "show4"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text43')))])]), _vm._v(" "), _c('dl', [_c('dt', {
    on: {
      "click": function($event) {
        _vm.show5 = !_vm.show5
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text47'))), _c('span', {
    staticClass: "fold_button",
    class: {
      fold_button2: _vm.show5
    }
  })]), _vm._v(" "), _c('dd', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show5),
      expression: "show5"
    }]
  }, [_vm._v(_vm._s(_vm.$t('solution3.text48')))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.imglist[7]),
      expression: "imglist[7]",
      arg: "background-image"
    }],
    staticClass: "content_item content_bg"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "button_default2",
    staticStyle: {
      "margin-bottom": "2.26rem"
    },
    on: {
      "click": function($event) {
        _vm.showDialog2()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('solution3.text45')))])])])]), _vm._v(" "), _c('footerLine')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "platform_pic clearfix"
  }, [_c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/solution/andriod.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/solution/ios.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('li', [_c('img', {
    attrs: {
      "src": require("../assets/images/solution/h5.png"),
      "alt": ""
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22e87801"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/solution2.vue
// module id = 89
// module chunks = 0